import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useHistory } from "react-router-dom";

import { PageLayout, PageHeader } from "../components/layout";
import { Loading } from "../components";
import RCAlertForm from "./components/RCAlertForm";
import "./rc-buy-alerts-page.scss";

const RCAlertEdit = () => {
  const history = useHistory();
  const { alertId } = useParams();
  const [alert, setAlert] = useState();

  useEffect(() => {
    let cancelled = false;
    axios.get(`/api/buy-alerts/${alertId}`).then(({ data }) => {
      if (!cancelled) setAlert(data);
    });
    return () => {
      cancelled = true;
    };
  }, [alertId]);

  return (
    <PageLayout className="rc-buy-alerts-page">
      <PageHeader
        title="Edit Buy Alert"
        description="Update the product, budget, filters, and notification preferences for this alert."
        backTo="/alerts"
      />

      <div className="rc-bap__form-wrap">
        {!alert ? (
          <Loading type="loading" showText={false} />
        ) : (
          <RCAlertForm
            alert={alert}
            afterSubmit={() => history.push("/alerts")}
          />
        )}
      </div>
    </PageLayout>
  );
};

export default RCAlertEdit;
